<template lang="pug">
  label.radio-label
    .mr-radio(:class="{selected: shouldBeChecked, disabled: disabled}")
      input(type="radio" :id="id" :name="name" :checked="shouldBeChecked" :value="value" @change="updateInput" :disabled="disabled")
    slot
</template>

<script>
  export default {
    name: "mrRadio",

    model: {
      prop: 'modelValue',
      event: 'change'
    },

    props: {
      id: {
        type:String
      },
      name: {
        type: String
      },
      value: {
      },
      modelValue: {
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      shouldBeChecked() {
        return this.modelValue == this.value;
      }
    },

    methods: {
      updateInput() {
        this.$emit('change', this.value);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .radio-label
    .mr-radio
      margin-right 0.5em
</style>
